/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuctionManagementListAuctionResponse } from './AuctionManagementListAuctionResponse';

export type AuctionManagementListAuctionResponseApiRespoonse = {
    data?: AuctionManagementListAuctionResponse;
    status?: AuctionManagementListAuctionResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AuctionManagementListAuctionResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

